var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items"},[_c('v-container',{staticClass:"my-5"},[_c('v-row',[_c('v-col',[_c('ItemsTable',{attrs:{"propHeaders":_vm.itemsHeaders,"propItems":_vm.items}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }